import ApprovalTimelineReadonly from './ApprovalTimelineReadonly';
import HeaderUang from './HeaderUang';

const CardUangReadonly = ({ item }) => {
  return (
    <div
      style={{
        background: '#fff',
        borderRadius: 12,
        padding: 20,
        marginBottom: 16,
        border: '1px solid #f0f0f0',
        marginLeft: 0,
        marginRight: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <HeaderUang item={item} />
      <hr style={{ border: 'none', borderTop: '1px solid #e5e7eb', margin: '12px 0 16px 0' }} />
      <div style={{ flexGrow: 1 }}>
        <ApprovalTimelineReadonly item={item} />
      </div>
    </div>
  );
};

export default CardUangReadonly;
